import React from 'react'
import { Link } from 'react-router'

const StudentCoins = ({coins}) => <span className="gamification-numbers">
  <span>{coins}</span>
  <span className="coin-circle">$</span>
</span>

const StudentScore = ({score}) => <span className="gamification-numbers">
  <span>{score}</span>
  <i className='fa fa-star' />
</span>

const StudentProfileDigest = (
  { userProfile: { first_name, last_name, avatar, score }, userCoins },
) => {
  const generateProfileStyle = avatar => {
    if (!avatar) return {}

    return {
      background: `url(${avatar})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }
  }

  return (
    <div className="profile-digest">
      {/* <Link to="/dashboard/profile">
        <div className="profile-pic" style={generateProfileStyle(avatar)}>
          {!avatar && <i className="fa fa-user" aria-hidden="true" />}
        </div>
      </Link> */}

      <Link to="/dashboard/profile">
        <StudentCoins coins={userCoins} />
        <StudentScore score={score} />
        <span className='student-name'>{`${first_name || ''} ${last_name || ''}`}</span>
      </Link>
    </div>
  )
}

export default StudentProfileDigest



// WEBPACK FOOTER //
// ./src/components/student/StudentProfileDigest.js